module.exports = __webpack_public_path__ + "static/img/jc.98e64ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jc.png
// module id = w9Tg
// module chunks = 1